/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MainStrategyEnum } from './MainStrategyEnum';
import {
    MainStrategyEnumFromJSON,
    MainStrategyEnumFromJSONTyped,
    MainStrategyEnumToJSON,
    MainStrategyEnumToJSONTyped,
} from './MainStrategyEnum';

/**
 * Event linking configuration for a definition.
 * 
 * ``clean()`` returns warnings as well as errors — informative ones about grouping fields that
 * match no data — so they are surfaced rather than only logged.
 * @export
 * @interface LinkingRuleRequest
 */
export interface LinkingRuleRequest {
    /**
     * 
     * @type {string}
     * @memberof LinkingRuleRequest
     */
    workflow: string;
    /**
     * If set, this rule only applies to events from batches belonging to this data provider. Leave blank for a rule that covers every provider without a rule of its own.
     * @type {string}
     * @memberof LinkingRuleRequest
     */
    dataProvider?: string | null;
    /**
     * Fields used to group events within a batch, e.g. ["site_id"] or ["site_id", "data_point.data.custom_field"]
     * @type {any}
     * @memberof LinkingRuleRequest
     */
    groupingFields: any | null;
    /**
     * Strategy for selecting the main event within a group.
     * 
     * * `oldest` - Oldest created
     * * `direct_match_first` - Direct match preferred
     * * `highest_flux` - Highest flux
     * @type {MainStrategyEnum}
     * @memberof LinkingRuleRequest
     */
    mainStrategy: MainStrategyEnum;
}



/**
 * Check if a given object implements the LinkingRuleRequest interface.
 */
export function instanceOfLinkingRuleRequest(value: object): value is LinkingRuleRequest {
    if (!('workflow' in value) || value['workflow'] === undefined) return false;
    if ((!('groupingFields' in (value as Record<string, any>)) && !('grouping_fields' in (value as Record<string, any>))) || ((value as Record<string, any>)['groupingFields'] === undefined && (value as Record<string, any>)['grouping_fields'] === undefined)) return false;
    if ((!('mainStrategy' in (value as Record<string, any>)) && !('main_strategy' in (value as Record<string, any>))) || ((value as Record<string, any>)['mainStrategy'] === undefined && (value as Record<string, any>)['main_strategy'] === undefined)) return false;
    return true;
}

export function LinkingRuleRequestFromJSON(json: any): LinkingRuleRequest {
    return LinkingRuleRequestFromJSONTyped(json, false);
}

export function LinkingRuleRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): LinkingRuleRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'workflow': json['workflow'],
        'dataProvider': json['data_provider'] === undefined ? undefined : json['data_provider'] === null ? null : json['data_provider'],
        'groupingFields': json['grouping_fields'],
        'mainStrategy': MainStrategyEnumFromJSON(json['main_strategy']),
    };
}

export function LinkingRuleRequestToJSON(json: any): LinkingRuleRequest {
    return LinkingRuleRequestToJSONTyped(json, false);
}

export function LinkingRuleRequestToJSONTyped(value?: LinkingRuleRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'workflow': value['workflow'],
        'data_provider': value['dataProvider'],
        'grouping_fields': value['groupingFields'],
        'main_strategy': MainStrategyEnumToJSON(value['mainStrategy']),
    };
}

